module.exports = __webpack_public_path__ + "static/img/BU01KB-3.544cd97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01KB-3.jpg
// module id = UoSG
// module chunks = 1